import { reportDayTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_DAYS, SET_REPORT_DAY_FILTERS, RESTORE_INITIAL } = reportDayTypes;

const initialState = {
  ReportDays: [],
  date: newDate(),
  station: null,
};

export const reportDayReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_DAYS:
      return { ...state, ReportDays: payload };
    case SET_REPORT_DAY_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
